export default "__VITE_ASSET__CMi14N05__ 120w, __VITE_ASSET__BTxXQQnG__ 240w, __VITE_ASSET__Do7SqrAx__ 480w, __VITE_ASSET__BTfJ7Vd5__ 512w";